import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const PasswordReset = lazy(
  () =>
    import('./PasswordReset.eager').then(mod => ({
      default: mod.PasswordReset,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
